export const messages = {
  en: {
    communityWechat: {
      title: 'Community WeChat',
      name: 'Name',
      communityName: 'Community Name',
      appId: 'APPID',
      appSecret: 'App Secret',
      description: 'Description',
      operation: 'Operation',
      add: 'Add',
      edit: 'Edit',
      cancel: 'Cancel',
      save: 'Save',
      required: 'Required',
      maxLength100: 'Cannot exceed 100 characters',
      maxLength200: 'Cannot exceed 200 characters',
      addSuccess: 'Add successful',
      editSuccess: 'Update successful'
    },
    addCommunityWechat: {
      title: 'Add WeChat',
      name: 'Name',
      appId: 'APPID',
      appSecret: 'App Secret',
      description: 'Description',
      remarks: 'Remarks',
      placeholder: {
        name: 'Required, please enter name',
        appId: 'Required, please enter APPID',
        appSecret: 'Required, please enter app secret',
        remarks: 'Optional, please enter description'
      }
    },
    editCommunityWechat: {
      title: 'Edit WeChat',
      name: 'Name',
      appId: 'APPID',
      appSecret: 'App Secret',
      description: 'Description',
      remarks: 'Remarks',
      placeholder: {
        name: 'Required, please enter name',
        appId: 'Required, please enter APPID',
        appSecret: 'Required, please enter app secret',
        remarks: 'Optional, please enter description'
      }
    },
  },
  zh: {
    communityWechat: {
      title: '小区公众号',
      name: '名称',
      communityName: '小区名称',
      appId: 'APPID',
      appSecret: '应用密钥',
      description: '描述',
      operation: '操作',
      add: '添加',
      edit: '修改',
      cancel: '取消',
      save: '保存',
      required: '不能为空',
      maxLength100: '不能超过100个字符',
      maxLength200: '不能超过200个字符',
      addSuccess: '添加成功',
      editSuccess: '修改成功'
    },
    addCommunityWechat: {
      title: '添加',
      name: '名称',
      appId: 'APPID',
      appSecret: '应用密钥',
      description: '描述',
      remarks: '备注',
      placeholder: {
        name: '必填，请填写名称',
        appId: '必填，请填写APPID',
        appSecret: '必填，请填写应用密钥',
        remarks: '选填，请填写描述信息'
      }
    },
    editCommunityWechat: {
      title: '修改公众号',
      name: '名称',
      appId: 'APPID',
      appSecret: '应用密钥',
      description: '描述',
      remarks: '备注',
      placeholder: {
        name: '必填，请填写名称',
        appId: '必填，请填写APPID',
        appSecret: '必填，请填写应用密钥',
        remarks: '选填，请填写描述信息'
      }
    },
  }
}